import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-app/initiate_cloud.webp";

function Initiatecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Initiate Your Cloud Journey <span>Today</span>
            </h2>
            <p>
              Get in touch and polish your idea into a value-driven cloud app
              leveraging the help of our professional cloud consultants. We’re
              here to cater to your diverse requirements.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Initiatecloud;
